module.exports = __webpack_public_path__ + "static/media/kickcounter.b288267e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/healthTools/kickcounter.png
// module id = 1419
// module chunks = 2